module.exports = __webpack_public_path__ + "img/ecoshopIconGreen.44bd9a09.png";